import { Router, UrlTree } from '@angular/router';
import { AppModule } from '../rbac/rbac.policy';
import { Officer } from '../models/officer.model';

/** First desk route the session can open (avoids guard redirect loops). */
const FALLBACK_NAV: ReadonlyArray<{ path: string; module: AppModule }> = [
  { path: '/administration', module: 'settings' },
  { path: '/dashboard', module: 'dashboard' },
  { path: '/settings', module: 'settings' },
  { path: '/roles', module: 'roles' },
  { path: '/profile', module: 'profile' },
];

export function normalizeAppPath(url: string): string {
  let path = (url.split('?')[0] || '/').trim();
  if (!path.startsWith('/')) path = `/${path}`;
  if (path.length > 1 && path.endsWith('/')) path = path.slice(0, -1);
  return path;
}

export function portalFallbackUrlTree(
  canModule: (module: AppModule) => boolean,
  router: Router,
): UrlTree {
  for (const { path, module } of FALLBACK_NAV) {
    if (canModule(module)) return router.createUrlTree([path]);
  }
  return router.createUrlTree(['/login'], { queryParams: { reason: 'access' } });
}

/** Default landing route after login or role switch. */
export function homeRouteForOfficer(officer: Officer | null | undefined): string {
  if (!officer) return '/dashboard';
  if (officer.homeRoute) return officer.homeRoute;
  const active = officer.activeRole || officer.role;
  if (active === 'administrator') return '/administration';
  if (active === 'records_officer') return '/dashboard';
  if (active === 'admin') return '/dashboard';
  return '/dashboard';
}

export function officerNeedsRoleChoice(officer: Officer | null | undefined): boolean {
  if (!officer) return false;
  const roles = officer.roles?.length ? officer.roles : officer.role ? [officer.role] : [];
  return roles.length > 1 && !officer.activeRole;
}
